// ============================================================================
// Suppress Angular Material Core Theme Warning in Development
// ============================================================================
//
// Angular Material components expect a "core theme" to be loaded. If no theme
// is provided, Angular logs a warning like:
//   "Could not find Angular Material core theme. Most Material components may not work as expected."
//
// This warning is harmless if you intentionally do not use a Material theme,
// but it can clutter the console during development. This snippet overrides
// console.warn to ignore only this specific message, leaving all other warnings intact.
//
// This implementation is robust and safe:
//   1. Checks if there are any arguments (args.length > 0)
//   2. Checks if the first argument is a string
//   3. Performs a strict match on the known warning substring
//   4. Preserves all other console.warn calls
//
// Notes:
//   - This does NOT affect production builds if placed in a dev-only check.
//   - No core Angular or browser functionality is modified, only console output.
//   - If Angular changes the warning text in the future, it may reappear.
//
// ============================================================================

if (typeof window !== 'undefined' && console && !('originalWarn' in console)) {
  // Save the original console.warn so we can call it for unrelated warnings
  const originalWarn = console.warn;

  console.warn = (...args: unknown[]) => {
    // Ensure there is at least one argument before accessing args[0]
    if (args.length > 0 && typeof args[0] === 'string') {
      const firstArg = args[0];

      // Ignore only the Angular Material core theme warning
      if (firstArg.includes('Angular Material core theme')) {
        return; // Suppress this specific warning
      }
    }

    // Call original console.warn for all other messages
    originalWarn(...args);
  };
}

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
